import styled from "styled-components";

const Logo = styled.img`
  width: 10rem;
  height: 8rem;
  object-fit: cover;
  cursor: pointer;
`;

export default Logo;
